import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'page-download',
  templateUrl: './page-download.component.html',
  styleUrls: ['./page-download.component.css']
})
export class PageDownloadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
